const STORAGE_KEY = 'enter-notification-banner-read-ids';

/** 獲取已讀 id 集合 */
export function getReadIds(): Set<number> {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    return new Set(JSON.parse(raw) as number[]);
}

/** 新增已讀 id */
export function addReadId(id: number): void {
    const ids = getReadIds();
    ids.add(id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
}

/** 測試用：清空已讀記錄 */
export function clearReadIds(): void {
    localStorage.removeItem(STORAGE_KEY);
}
